export interface Payment {
  actuallyPriceList: Partial<Record<PaymentCurrency, Partial<Record<PaymentPeriod, PaymentProduct[]>>>>;
  choosenProducts?: Partial<Record<PaymentCurrency, Partial<Record<PaymentPeriod, PaymentProduct[]>>>>;
  avaliablePaymentMethods: PaymentMethods[];
  countOfMonthToBuy?: number;
  endPeriodDate?: string;
}

export type PaymentCurrency = 'USD' | 'EUR' | 'PLN';
export type PaymentPeriod = 'oneTime' | 'month' | 'term' | 'year' | 'week_trial' | '6_months';
export type ProRole = 'admin' | 'employee';
export type ProStatus = 'active' | 'cancelled';
export type PaymentMethods = 'przelewy24' | 'przelewy24-proforma' | 'proforma';

export interface PaymentProduct {
  product: PaymentSubscription;
  autoDiscount: {
    discount: PaymentDiscount;
    isOnlyOneUse: boolean;
  };
}
export interface PaymentSubscription {
  id: number;
  name: string;
  description: string;
  price: number;
  monthlyPrice: number;
  originalMonthlyPrice?: number;
  constPercentDiscount?: number;
  currency: PaymentCurrency;
  countOfSlots: number;
  isSubscription: boolean;
  country: string;
  durationPeriod: PaymentPeriod;
  requestCount?: number;
}

export interface PaymentDiscount {
  id: number;
  description: string;
  code?: string;
  amount?: number;
  percent?: number;
  extraDays?: number;
  startExpirationDate?: Date;
  endExpirationDate?: Date;
  percentAmount?: number;
}

export interface PaymentDiscountSubSlot {
  slotsDiscount: PaymentDiscountProduct;
  subscriptionDiscount: PaymentDiscountProduct;
}

export interface PaymentDiscountProduct {
  discount: PaymentDiscount;
  isOnlyOneUse: boolean;
}

export interface PaymentData {
  subscriptionProductId?: number;
  subscriptionConstPercentDiscount?: number;
  slotsProductId?: number;
  slotsConstPercentDiscount?: number;
  expectedCountOfSlots: number;
  expectedPeriod: PaymentPeriod;
  expectedCurrency: PaymentCurrency;
  expectedPrice: number;
  expectedCountry: string;
  discountCode?: string;
  nameOrder: string;
  descriptionOrder: string;
  applicationLanguage: string;
  automaticSubscriptionDiscountId?: number;
  subscriptionDiscountIds?: number[];
  automaticSlotsDiscountId: number;
  slotsDiscountIds: number[];
  subscriptionName?: string;
  slotsName?: string;
  isCompany: boolean;
  choosenPaymentMethod: PaymentMethods;
}

export interface PaymentApiData {
  expectedCountOfSlots: number;
  expectedRequestCount: number;
  expectedPrice: number;
  applicationLanguage: string;
  nameOrder: string;
  descriptionOrder: string;
  choosenPaymentMethod: PaymentMethods;
  choosenCurrency: PaymentCurrency;
  choosenProduct: {
    id: number;
    name: string;
    description: string;
    country: string;
  };
}

export interface DiscountData {
  code: string;
  subscriptionId: number;
  slotsId?: number;
  isCountrySubscription: 0 | 1;
  isCountrySlots: 0 | 1;
}

export interface Invoice {
  name: string;
  pdfUrl: string;
  issueDate: string;
  issueEndDate: string;
  price: string;
}

export interface AboutPro {
  slots: PaymentSlot[];
  period: string;
  startPeriodDate: string;
  endPeriodDate: string;
  price: number;
  currency: string;
  description: string;
  status: ProStatus;
  isCancellable: boolean;
  isSubscription: boolean;
  isRenewable: boolean;
  isTrial: boolean;
  isExtendable: boolean;
}

export interface PaymentSlot {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  role: ProRole;
  isVerified: boolean;
  isRegistered?: boolean;
}

export interface AssignSlotData {
  newUserEmail: string;
  lang: string;
  firstName: string;
  lastName: string;
}

export interface UpdateSlotData {
  slotId: number;
  firstName: string;
  lastName: string;
}

export interface AssignMultipleSlotData {
  users: { newUserEmail: string; firstName: string; lastName: string }[];
  lang: string;
}

export interface AssignMultipleSlotResponse {
  addedUsersCount: number;
  failedCount: number;
  failedUsers: string[];
  slots: PaymentSlot[];
}

export class Payment implements Payment {}
export class AboutPro implements AboutPro {}
